const injectScript = (src, callback) => {
  let script = document.createElement('script');
  const prior = document.getElementsByTagName('script')[0];
  script.async = 1;
  prior.parentNode.insertBefore(script, prior);

  script.onload = () => {
    if (callback) {
      callback();
    }
  };

  script.src = src;
};

export default injectScript;



// WEBPACK FOOTER //
// ./src/common/utils/injectScript.js